/* global $, data, query_string */
/* eslint-disable no-use-before-define */
import * as d3 from 'd3'
import table from 'bam-node-savant-table/table'

let ticking = false
let isFixedHeaderShowing = false
const tableDivId = 'tools'

$(document).ready(() => {
    $('form').submit(false)

    $('#ddlRange').change(() => {
        $('#lblRange').html(`Range: ${$('#ddlRange option:selected').text()}`)
    })

    $('#ddlTeamId').change(() => {
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    })

    $('#toggleViz').change(() => {
        $('#lblToggleViz').html($('#toggleViz option:selected').text())
        loadTable(data, true)
        if ($('#toggleViz').val() === 'show') {
            setTimeout(sortLoadChart, 50)
        }
        populateUrl()
    })

    $('#ddlStartSeason').change(() => {
        $('#lblStartSeason').html(`Start Year: ${$('#ddlStartSeason').val()}`)
    })

    $('#ddlEndSeason').change(() => {
        $('#lblEndSeason').html(`End Year: ${$('#ddlEndSeason').val()}`)
    })

    $('#ddlSplitYears').change(() => {
        $('#lblSplitYears').html(`Split Years: ${$('#ddlSplitYears').val()}`)
    })

    $('#ddlMin').change(() => {
        $('#lblMin').html($('#ddlMin option:selected').text())
    })
    $('#ddlPos').change(() => {
        $('#lblPos').html($('#ddlPos option:selected').text())
    })

    $('#ddlAdjFielderRole').click(() => {
        $('#roleSelectors').toggle()
    })

    $('#btnRoleBoxClose').click(() => {
        $('#roleSelectors').hide()
    })

    let is1bChecked = false
    let is2bChecked = false
    let isSSChecked = false
    let is3bChecked = false
    let isLfChecked = false
    let isCfChecked = false
    let isRfChecked = false

    $('.fielder-role').click(function handleClick() {
        const id = this.id.split('_')[1]
        if (id === 'ss') {
            isSSChecked = !isSSChecked
            $('.is_ss').prop('checked', isSSChecked)
        }
        if (id === '1b') {
            is1bChecked = !is1bChecked
            $('.is_1b').prop('checked', is1bChecked)
        }
        if (id === '2b') {
            is2bChecked = !is2bChecked
            $('.is_2b').prop('checked', is2bChecked)
        }
        if (id === '3b') {
            is3bChecked = !is3bChecked
            $('.is_3b').prop('checked', is3bChecked)
        }
        if (id === 'lf') {
            isLfChecked = !isLfChecked
            $('.is_lf').prop('checked', isLfChecked)
        }
        if (id === 'cf') {
            isCfChecked = !isCfChecked
            $('.is_cf').prop('checked', isCfChecked)
        }
        if (id === 'rf') {
            isRfChecked = !isRfChecked
            $('.is_rf').prop('checked', isRfChecked)
        }

        const roles = getSelectedRoles()
        $('#hfFielderRoles').val(roles.join(','))
        if (roles.length === 0) {
            $('#lblFielderRoles').html('Detailed Fielder Roles')
        } else {
            $('#lblFielderRoles').text(
                `Detailed Fielder Roles (${roles.length})`
            )
        }
    })

    function getSelectedRoles() {
        const roles = []
        $('.fielder-role:checkbox:checked').each(function handleEach() {
            const role = this.id.split('_')[1]
            if (
                role !== 'ss' &&
                role !== '1b' &&
                role !== 'ss' &&
                role !== '3b' &&
                role !== 'lf' &&
                role !== 'cf' &&
                role !== 'rf'
            ) {
                roles.push(role)
            }
        })

        return roles
    }

    if (query_string.roles) {
        $('#hfFielderRoles').val(query_string.roles)
        const roles = query_string.roles.split(',')
        for (let i = 0; i < roles.length; i++) {
            $(`#adjrole_${roles[i]}`).prop('checked', true)
        }

        if (roles.length === 0) {
            $('#lblFielderRoles').html('Detailed Fielder Roles')
        } else {
            $('#lblFielderRoles').text(
                `Detailed Fielder Roles (${roles.length})`
            )
        }
    }

    if (query_string.viz) {
        $('#toggleViz').val(query_string.viz).attr('selected', true)
        $('#lblToggleViz').html($('#toggleViz option:selected').text())
    }

    if (query_string.type) {
        $('#ddlType').val(query_string.type).attr('selected', true)
        $('#lblType').html(`View: ${$('#ddlType option:selected').text()}`)

        if ($('#ddlType').val().includes('Team')) {
            $('#min-form-group').hide()
        }
    }

    if (query_string.startYear) {
        $('#ddlStartSeason').val(query_string.startYear).attr('selected', true)
        $('#lblStartSeason').html(`Start Year: ${$('#ddlStartSeason').val()}`)
    }

    if (query_string.split) {
        $('#ddlSplitYears').val(query_string.split).attr('selected', true)
        $('#lblSplitYears').html(`Split Years: ${$('#ddlSplitYears').val()}`)
    }

    if (query_string.endYear) {
        $('#ddlEndSeason').val(query_string.endYear).attr('selected', true)
        $('#lblEndSeason').html(`End Year: ${$('#ddlEndSeason').val()}`)
    }

    if (query_string.team) {
        $('#ddlTeamId').val(query_string.team).attr('selected', true)
        $('#lblTeamId').html($('#ddlTeamId option:selected').text())
    }

    if (query_string.range) {
        $('#ddlRange').val(query_string.range).attr('selected', true)
        $('#lblRange').html(`Range: ${$('#ddlRange option:selected').text()}`)
    }

    if (query_string.min) {
        $('#ddlMin').val(query_string.min).attr('selected', true)
        $('#lblMin').html($('#ddlMin option:selected').text())
    }
    if (query_string.pos) {
        $('#ddlPos').val(query_string.pos).attr('selected', true)
        $('#lblPos').html($('#ddlPos option:selected').text())
    }
    if (query_string.sortDir) {
        $('#sortDir').val(query_string.sortDir)
    }

    if (query_string.sort) {
        $('#sort').val(query_string.sort)
    }

    if (data && data.length > 0) {
        loadTable(data, false)
    } else {
        $('#NoData').html('<h1>No Data Found.</h2>')
    }

    $(document).on('click', '.th-component-header', () => {
        if ($('#toggleViz').val() === 'show') {
            setTimeout(sortLoadChart, 50)
        }
    })

    function loadTable(dataLoad) {
        const sortDirection = $('#sortDir').val()

        const headers = [
            {
                name: 'Player',
                field: 'href',
                customSortField: 'entity_name',
                headerClass:
                    'th-component-header align-left th-vertical-bottom table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
                photo: '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
                photoId: 'entity_id',
            },
            {
                name: 'Team',
                field: 'display_team_name',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'tr-data align-center',
                photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror=\'\';this.src=\'https://baseballsavant.mlb.com/site-core/images/savant-mlb.svg\'" />',
                photoId: 'team_id',
                photoOnly: true,
            },
            {
                name: $('#ddlSplitYears').val() === 'yes' ? 'Year' : '',
                field: 'year',
                type: 'number',
                headerClass: 'th-component-header th-vertical-bottom',
                fieldClass: 'tr-data',
            },
            {
                name: 'Pos',
                field: 'primary_pos_formatted',
                headerClass:
                    'th-component-header align-center min-column-width th-vertical-bottom',
                fieldClass: 'tr-data align-center min-column-width',
            },
            {
                name: 'Runs<br/>Prevented',
                field: 'fielding_runs_prevented',
                headerClass:
                    'th-component-header min-column-width th-align-left',
                fieldClass: 'tr-data min-column-width',
                type: 'number',
            },
            {
                name: 'OAA',
                field: 'outs_above_average',
                headerClass: 'th-component-header th-vertical-bottom',
                fieldClass: 'tr-data',
                type: 'number',
                highlightDynamic: true,
            },
            {
                name: '',
                uniqueId: 'vizId',
                headerClass:
                    'th-component-header align-center th-vertical-bottom',
                fieldClass: 'doaa tr-data align-center',
                skipSort: true,
            },
            {
                name: 'In',
                field: 'outs_above_average_infront',
                headerClass:
                    'th-component-header  border-left th-vertical-bottom',
                fieldClass: 'tr-data border-left',
                type: 'number',
            },
            {
                name: 'To<br/>Player&apos;s Right',
                field: 'outs_above_average_lateral_toward3bline',
                headerClass: 'th-component-header th-align-left',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'To<br/>Player&apos;s Left',
                field: 'outs_above_average_lateral_toward1bline',
                headerClass: 'th-component-header th-align-left',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'Back',
                field: 'outs_above_average_behind',
                headerClass: 'th-component-header th-vertical-bottom',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'RHB',
                field: 'outs_above_average_rhh',
                headerClass:
                    'th-component-header border-left th-vertical-bottom',
                fieldClass: 'tr-data border-left',
                type: 'number',
            },
            {
                name: 'LHB',
                field: 'outs_above_average_lhh',
                headerClass: 'th-component-header th-vertical-bottom',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'Success Rate',
                field: 'actual_success_rate_formatted',
                headerClass:
                    'th-component-header border-left th-vertical-bottom',
                fieldClass: 'tr-data border-left',
                type: 'number',
            },
            {
                name: 'Estimated<br/>Success Rate',
                field: 'adj_estimated_success_rate_formatted',
                headerClass: 'th-component-header th-align-left',
                fieldClass: 'tr-data',
                type: 'number',
            },
            {
                name: 'Success<br/>Rate Added',
                field: 'diff_success_rate_formatted',
                headerClass: 'th-component-header th-align-left',
                fieldClass: 'tr-data',
                type: 'number',
            },
        ]

        const secondaryHeaders = [
            {
                name: '',
                colspan: 8,
                headerClass: 'th-name-header',
            },
            {
                name: 'Outs Above Average',
                colspan: 6,
                headerClass: 'th-title-header',
            },
            {
                name: '',
                colspan: 3,
                headerClass: 'th-name-header',
            },
        ]

        /* if ($("#ddlSplitYears").val() === "no") {
            headers.splice(2, 1);
            secondaryHeaders[0].colspan = 7;
        } */

        if (
            query_string.type === 'League' ||
            query_string.type === 'Fielder_Pos' ||
            query_string.type === 'Fielder_Role'
        ) {
            headers[0] = {
                name: '',
                field: 'href',
                headerClass:
                    'th-component-header align-left  th-vertical-bottom table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
            }
            headers[1].name = ''
            headers[1].photo = ''
            headers[2].name = ''
            headers[3].name = ''
        }

        if (
            query_string.type === 'Fielding_Team' ||
            query_string.type === 'Batting_Team'
        ) {
            headers[0] = {
                name: 'Team',
                field: 'href',
                headerClass:
                    'th-component-header align-left  th-vertical-bottom table-static-column',
                fieldClass: 'tr-data align-left table-static-column',
            }
            headers[1].photoId = 'entity_id'
            headers[1].name = ''
            headers[3].name = ''
        }

        const width = $(`#${tableDivId}`).outerWidth()
        let repeatHeaders = false
        if (width <= 768) {
            repeatHeaders = 7
        }
        // eslint-disable-next-line no-new, new-cap
        new table({
            id: 'tools',
            repeatHeader: repeatHeaders,
            secondaryHeaders,
            headers,
            data: dataLoad,
            uniqueId: 'vizId',
            defaultSort:
                headers[Number($('#sort').val())].customSortField ||
                headers[Number($('#sort').val())].field,
            defaultSortDirection: sortDirection,
            sortClass: 'column-sort',
            showRank: true,
        })

        $('.th-component-rank').css('vertical-align', 'bottom')
        $('.th-component-rank').addClass('th-component-header')
    }

    window.addEventListener('scroll', () => {
        if (!ticking && data.length) {
            window.requestAnimationFrame(() => {
                checkHeaderPosition(tableDivId)
                ticking = false
            })

            ticking = true
        }
    })

    function checkHeaderPosition(divId) {
        const scrollPosY = window.scrollY
        const posTop = $(`#${divId}`).offset().top
        const height = $(`#${divId} table thead`).height()
        if (!isFixedHeaderShowing && posTop < scrollPosY) {
            isFixedHeaderShowing = true
            addStaticHeader(divId)
        } else if (isFixedHeaderShowing && posTop - height > scrollPosY) {
            $(`#${divId} table thead`).removeClass('fixed-header')
            isFixedHeaderShowing = false
        }
    }

    function addStaticHeader(divId) {
        const width = $(`#${divId}`).outerWidth()
        // $(".tr-component-row th").removeClass("column-sort");

        if (width && width > 767) {
            let tableCell = 0

            // Set TH Width before applying fixed-header
            $('.default-table-row')
                .first()
                .children('td')
                .each(function handleEach() {
                    const rowWidth = $(this).outerWidth()
                    $(`.tr-component-row th:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell++ // eslint-disable-line
                })

            $(`#${divId} table thead`).addClass('fixed-header')
            tableCell = 0

            // Set TD Width before applying fixed-header
            $('.tr-component-row')
                .children('th')
                .each(function handleEach() {
                    const rowWidth = $(this).outerWidth()
                    $(`.default-table-row td:nth-child(${tableCell + 1})`).css(
                        'width',
                        rowWidth
                    )
                    tableCell++ // eslint-disable-line
                })
        }
    }

    window.addEventListener('resize', () => {
        if (isFixedHeaderShowing) {
            addStaticHeader(tableDivId)
        }
    })

    function getUrl() {
        return `/leaderboard/outs_above_average?type=${$(
            '#ddlType'
        ).val()}&startYear=${$('#ddlStartSeason').val()}&endYear=${$(
            '#ddlEndSeason'
        ).val()}&split=${$('#ddlSplitYears').val()}&team=${$(
            '#ddlTeamId'
        ).val()}&range=${$('#ddlRange').val()}&min=${$(
            '#ddlMin'
        ).val()}&pos=${$('#ddlPos').val()}&roles=${$(
            '#hfFielderRoles'
        ).val()}&viz=${$('#toggleViz').val()}`
    }

    $('#btnUpdate').click(() => {
        window.location.href = getUrl()
    })

    $('#btnCSV').click(() => {
        window.location.href = `${getUrl()}&csv=true`
    })

    $('#btnClear').click(() => {
        window.location.href = '/leaderboard/outs_above_average'
    })

    $('#ddlType').change(() => {
        query_string.type = $('#ddlType').val()
        window.location.href = getUrl()
    })

    $(document).on('click', 'th.th-component-header', function handleEach() {
        const id = this.id.split('-')[1]

        if (Number($('#sort').val()) === Number(id)) {
            if ($('#sortDir').val() === 'desc') {
                $('#sortDir').val('asc')
            } else {
                $('#sortDir').val('desc')
            }
        } else {
            $('#sortDir').val('desc')
        }
        $('#sort').val(id)
        isFixedHeaderShowing = false
        checkHeaderPosition(tableDivId)
        populateUrl()
    })

    function populateUrl() {
        const url = `${getUrl()}&sort=${$('#sort').val()}&sortDir=${$(
            '#sortDir'
        ).val()}`
        window.history.pushState('', '', url)
        return url
    }
})

const type = 'entity_id'

function sortLoadChart() {
    data.forEach((d) => {
        loadChart(d, `tools-tr_viz_${d[type]}_${d.year}`, 100, false)
    })
}

if ($('#toggleViz').val() === 'show') {
    data.forEach((d) => {
        loadChart(d, `tools-tr_viz_${d[type]}_${d.year}`, 100, false)
    })
}

function loadChart(playerData, id, size, showTitle) {
    let showRect = false
    if (id === 'chartLoad') {
        showRect = true
    }

    const oaaData = [
        {
            oaa: playerData.outs_above_average_infront,
        },
        {
            oaa: playerData.outs_above_average_lateral_toward1bline,
        },
        {
            oaa: playerData.outs_above_average_behind,
        },
        {
            oaa: playerData.outs_above_average_lateral_toward3bline,
        },
    ]

    const opts = {
        div_id: id,
        width: size,
        showRect,
        name: playerData.entity_name,
        data: oaaData,
        showFrequency: true,
        showTitle,
        showNumbers: true,
    }
    InfieldDefenseByAngle(opts)
}

function InfieldDefenseByAngle(opts) {
    const screenWidth = opts.width

    const margin = { left: 0, top: 0, right: 0, bottom: 0 }
    const width = Math.min(screenWidth, 250) - margin.left - margin.right
    const height = Math.min(screenWidth, 250) - margin.top - margin.bottom
    const radius = Math.min(width, height) / 5
    const innerRadius = 0.15 * radius

    let svg = d3
        .select(`#${opts.div_id}`)
        .select('.doaa')
        .append('svg')
        .attr('id', `svg_${opts.div_id}`)
        .attr('width', width + margin.left + margin.right)
        .attr('height', height + margin.top + margin.bottom)

    if (opts.showRect) {
        svg.append('rect')
            .attr('width', '100%')
            .attr('height', '100%')
            .attr('fill', '#fff')
    }
    svg = svg
        .append('g')
        .attr('class', 'wrapper')
        .attr(
            'transform',
            `translate(${width / 2 + margin.left},${height / 2 + margin.top})`
        )

    /// ///////////////////////////////////////////////////////////
    /// ////////////////// Data &  Scales /////////////////////////
    /// ///////////////////////////////////////////////////////////

    // Create a color scale
    const blueGrayRed = ['#0071c0', '#0071c0', '#f3f3f3', '#f31912', '#f31912']
    const colorScale = d3
        .scaleLinear()
        .domain([-200, -18, 0, 18, 200])
        .range(blueGrayRed)

    // Create font scale
    const fontSizeTitle = d3.scaleLinear().domain([0, 500]).range([8, 20])

    // Create an arc function

    let size = d3.max(data, (d) => Number(d.outs_above_average_infront))

    if (
        $('#ddlType').val().indexOf('Team') > -1 &&
        $('#ddlSeason').val() !== 'all'
    ) {
        size = 14
    } else if (
        $('#ddlType').val().indexOf('Team') > -1 &&
        $('#ddlSeason').val() === 'all'
    ) {
        size = 35
    } else if ($('#ddlSeason').val() === 'all') {
        size = 45
    }

    const arc = d3
        .arc()
        .outerRadius(radius)
        .innerRadius((d) => {
            if (opts.showFrequency) {
                return (
                    (radius - innerRadius) * ((d.data.oaa + size) / size) +
                    innerRadius
                )
            }
            return radius
        })

    const arcOuter = d3
        .arc()
        .innerRadius(innerRadius)
        .outerRadius((d) => {
            if (opts.showFrequency) {
                const test = d.data.oaa + 7
                return (radius - innerRadius) * (test / 7) + innerRadius
            }
            return radius
        })

    // Turn the pie chart 90 degrees counter clockwise, so it starts at the left
    const pie = d3
        .pie()
        .startAngle((315 * Math.PI) / 180)
        .endAngle((315 * Math.PI) / 180 + 2 * Math.PI)
        .value(() => 1)
        .padAngle(0.01)
        .sort(null)

    /// ///////////////////////////////////////////////////////////
    /// ///////////////// Create Donut Chart //////////////////////
    /// ///////////////////////////////////////////////////////////

    // Create the donut slices and also the invisible arcs for the text
    svg.selectAll('.donutArcs')
        .data(pie(opts.data))
        .enter()
        .append('path')
        .attr('class', 'donutArcs')
        .attr('d', arc)
        .style('fill', (d) => colorScale(d.data.oaa))
        .style('stroke', '#000')
        .style('stroke-width', 1)

    const leagueAvgData = [
        {
            oaa: 0,
            text: 'Back',
        },
        {
            oaa: 0,
            text: 'Lateral 1B',
        },
        {
            oaa: 0,
            text: 'In',
        },
        {
            oaa: 0,
            text: 'Lateral 3B',
        },
    ]

    svg.selectAll('.la')
        .data(pie(leagueAvgData))
        .enter()
        .append('path')
        .attr('class', 'donutArcs')
        .attr('d', arcOuter)
        .style('fill', 'none')
        .style('stroke', '#c2c2c2')
        .style('stroke-width', 1.3)

    if (opts.showTitle) {
        svg.append('text')
            .attr('y', -(height / 1.2))
            .attr('text-anchor', 'middle') // text-align: right
            .text(opts.name)
            .style('font-size', fontSizeTitle(width))
    }
}
